import request from '@/utils/request'

// 登录
export function login(data) {
  return request({
    url: '/user/doLogin',
    method: 'post',
    data: data
  })
}

// 登出
export function logout() {
  return request({
    url: '/user/logout',
    method: 'post'
  })
}

// 获取用户信息
export function getUserInfo() {
  return request({
    url: '/user/info',
    method: 'get'
  })
}

// 用户注册
export function register(data) {
  return request({
    url: '/user/register',
    method: 'post',
    data: data
  })
}

// 获取所有用户
export function allUsers(currentPage, pageSize,data) {
  return request({
    url: '/user/allUsers?currentPage=' + currentPage + '&pageSize=' + pageSize,
    method: 'post',
    data: data
  })
}

export function updateUser(data) {
  return request({
    url: '/user/updateUser',
    method: 'post',
    data: data
  })
}

export function deleteUser(id) {
  return request({
    url: '/user/deleteUser/'+ id,
    method: 'delete',
  })
}

export function sendEmailCodeApi(email) {
  return request({
    url: `/user/sendEmailCode`,
    method: 'get',
    params:{
      email:email
    }
  })
}

export function getAllUsers() {
  return request({
    url: `/user/getAllUsers`,
    method: 'get',
  })
}

export function forgotPasswordApi(data) {
  return request({
    url: `/user/email/forgot`,
    method: 'post',
    data
  })
}
// export function allUsers() {
//   return request({
//     url: '/user/allUsers',
//     method: 'get',
//   })
// }

